import entities from './entities'
import { TEntityName, TEntityResource } from './types'

export function getResource<E extends TEntityName>(
  entityName: E,
): TEntityResource<E> {
  return entities[entityName].endpoint
}
